import "../App.css";
import { FC, useCallback, useEffect, useState } from "react";
import Sidebar from "../navigation/sidebar/Sidebar";
import About from "./About";
import TheAnalyticSample from "../sections/section1/TheAnalyticSample";
import WeighingTheFactors from "../sections/section2/WeighingTheFactors";
import SpousesPartners from "../sections/section3/SpousesPartners";
import Search from "../sections/section4/Search";
import NegotiationProcess from "../sections/section5/TheNegotiationProcess";
import NegotiationTerms from "../sections/section6/TheNegotiationTerms";
import TheTransition from "../sections/section7/TheTransition";
import OverallImpressions from "../sections/section8/OverallImpressions";
import PreEmptiveRetentions from "../sections/section9/Pre-emptiveRetentions";
import Appendix from "../sections/section10/Appendix";
import { Container, Grid, CssBaseline } from "@mui/material";
import { Route, Routes, useLocation, Navigate, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { ApplicableYear } from "../models/responseData";

interface SectionState {
  [section: string]: boolean;
}

interface ExitRetentionReportProps {
  applicableYearsList: ApplicableYear[] | null
}

const ExitRetentionReport: FC<ExitRetentionReportProps> = ({ applicableYearsList }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { institution, year } = useParams();

  useEffect(() => {
    // navigate home if user changes url param to invalid year
    if (applicableYearsList && year) {
      if (!applicableYearsList?.map((yearItem) => yearItem.year).includes(Number(year))) {
        navigate('/');
      }
    }
  }, [year, applicableYearsList, navigate])

  const [sectionState, setSectionState] = useState<SectionState>({
    "The Analytic Sample": false,
    "Weighing The Factors": false,
    "Spouses & Partners": false,
    "Spouses & Partners/Role of spouse/partner career in search and outside offer": false,
    "Spouses & Partners/Type of positions held by spouses/partners": false,
    "The Search": false,
    "The Search/Initial contact between your faculty and offering institution": false,
    "The Negotiation Process": false,
    "The Negotiation Terms": false,
    "The Negotiation Terms/Permissible uses of startup funds in outside offer": false,
    "The Negotiation Terms/Counteroffers sought and counteroffers received": false,
    "The Negotiation Terms/Your counteroffer: Proposed changes": false,
    "The Transition": false,
    "Overall Impressions": false,
    "Overall Impressions/The top change to convince faculty to stay": false,
    "Preemptive Retentions": false,
    "Preemptive Retentions/Proposed Changes": false,
    "Appendix": false
  });

  const toggleSection = useCallback((section: string, open?: boolean) => {
    if (open) {
      setSectionState((prevState) => ({
        ...prevState,
        [section]: true
      }))
    } else {
      setSectionState((prevState) => ({
        ...prevState,
        [section]: !prevState[section]
      }))
    }
  }, [])

  return (
    <div>
      <>
        <CssBaseline />
        <Grid container>
          {location.pathname !== "/" &&
            <Grid item>
              <Sidebar
                sectionState={sectionState}
                toggleSection={toggleSection}
              />
            </Grid>
          }
          <Grid item xs={12} sm={location.pathname === "/" ? 12 : 9} md={location.pathname === "/" ? 12 : 8}>
            <Container>
              <main>
                {institution && <Header institutionName={institution} />}
                <Routes>
                  <Route path="/" element={<Navigate to="about-this-report" />} />
                  <Route path="about-this-report" element={<About />} />
                  <Route
                    path="the-analytic-sample/:subsection"
                    element={<TheAnalyticSample toggleSection={toggleSection} />}
                  />
                  <Route
                    path="weighing-the-factors/:subsection"
                    element={<WeighingTheFactors toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/spouses-&-partners/:subsection"
                    element={<SpousesPartners toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/the-search/:subsection"
                    element={<Search toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/the-negotiation-process/:subsection"
                    element={<NegotiationProcess toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/the-negotiation-terms/:subsection"
                    element={<NegotiationTerms toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/the-transition/:subsection"
                    element={<TheTransition toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/overall-impressions/:subsection"
                    element={<OverallImpressions toggleSection={toggleSection} />}
                  />
                  <Route
                    path="/preemptive-retentions/:subsection"
                    element={<PreEmptiveRetentions toggleSection={toggleSection} />}
                  />
                  <Route path="/appendix" element={<Appendix toggleSection={toggleSection} />} />
                  <Route path="/appendix/:subsection" element={<Appendix toggleSection={toggleSection} />} />
                </Routes>
              </main>
            </Container>
          </Grid>
        </Grid>
      </>
    </div>
  );
}

export default ExitRetentionReport;
